import { Component, OnInit, Input, Output, EventEmitter, Optional, Inject } from '@angular/core';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';
import { MatTableDataSource } from '@angular/material/table';
import { TracingPlanTaskItem } from '../../../../models/tracing-plan-task-item';

@Component({
    selector: 'mvf-iterative-task',
    templateUrl: 'iterative-task.component.html'
})

export class IterativeTaskComponent implements OnInit {
    iterativeDataSource: MatTableDataSource<TracingPlanTaskItem>[] = [];

    iterativeTaskDisplayedColumns: string[] = [
        //'assignedRole',
        'expirationDate',
        'lastActionDate',
        'progressPercent',
        'actions'
    ];
    readOnly: boolean;

    @Input()
    set iterableTask(value: TracingPlanTaskItem[]) {
          const groupedTaskObj = value.filter(x => x.grouperId)
            .reduce((prev, curr) => {
              (prev[curr.grouperId] = prev[curr.grouperId] || []).push(curr);
              return prev;
            }, {} as {[x: string]: TracingPlanTaskItem[]});
          this.iterativeDataSource = Object.values(groupedTaskObj)
            .map(arr => new MatTableDataSource(arr));
    }

    @Output()
    actionClicked = new EventEmitter<TracingPlanTaskItem>();

    @Input()
    label: string = 'TRACING_PLAN_DETAIL.ITERATIVE_TASK_LABEL';

    constructor(
        @Optional()
        @Inject(MAT_DIALOG_DATA)
        private dialogData: {tasks: TracingPlanTaskItem[], readonly: boolean}
    ) {
        if (this.dialogData) {
            this.iterableTask = this.dialogData.tasks;
            this.readOnly = this.dialogData.readonly;
        }
     }

    ngOnInit() { }

    getIterativeTaskGroupProgress(tasks: TracingPlanTaskItem[]): number {
        return tasks.filter(x => x.progressPercent == 1).length / tasks.length;
    }
}